// extracted by mini-css-extract-plugin
module.exports = {"Button":"TipListItem_Button__9j7pv"};